import { type RadioProps, styled } from '@mui/material';

export const CheckboxButtonIcon = styled('span', {
  shouldForwardProp: (prop: string) => !['isError', 'size'].includes(prop),
})<{ isError: boolean; size: RadioProps['size'] }>(({ theme, isError, size }) => ({
  borderRadius: '4px',
  border: `1.5px solid ${isError ? theme.palette.case.red.r600 : theme.palette.case.neutral.n400}`,
  width: size === 'small' ? 16 : 20,
  height: size === 'small' ? 16 : 20,
  background: theme.palette.case.neutral.n0,

  'input:hover ~ &': {
    borderColor: isError ? theme.palette.case.red.r600 : theme.palette.case.aquamarine.a700,
  },
  'input:disabled ~ &': {
    borderColor: theme.palette.case.neutral.n200,
  },
}));

export const CheckboxCheckedIcon = styled(CheckboxButtonIcon)(({ theme, size, isError }) => ({
  border: `1.5px solid ${isError ? theme.palette.case.red.r600 : theme.palette.case.aquamarine.a600}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isError ? theme.palette.case.red.r600 : theme.palette.case.aquamarine.a600,

  '&:before': {
    display: 'block',
    position: 'absolute',
    transform: 'translate(-43%, -48%) rotate(45deg)',
    left: '48%',
    top: '43%',
    width: size === 'small' ? '6px' : '8px',
    height: size === 'small' ? '10px' : '12px',
    border: `solid ${theme.palette.case.neutral.n0}`,
    borderWidth: '0 1.5px 1.5px 0',
    content: '""',
  },

  'input:hover ~ &': {
    backgroundColor: isError ? theme.palette.case.red.r600 : theme.palette.case.aquamarine.a700,

    '&:before': {
      backgroundColor: isError ? theme.palette.case.red.r600 : theme.palette.case.aquamarine.a700,
    },
  },
  'input:disabled ~ &': {
    borderColor: theme.palette.case.neutral.n200,
    backgroundColor: theme.palette.case.neutral.n200,
    '&:before': {
      backgroundColor: theme.palette.case.neutral.n200,
    },
  },
}));
